<template>

    <div class="container">
        <h2 v-html="lang('categories.overview.header')"></h2>
        <div class="row categoriesrow">
            <div
                class="col-sm-3"
                v-for="(category, key) in categories.data"
                v-if="category.product_count > 0"
                :key="'category-' + key"
            >
                <inertia-link
                    :href="route('categories.item', {slug:category.slug})"
                >
                    {{ category.name }} ({{ category.product_count }})
                    <i class="mdi mdi-chevron-right"></i>
                </inertia-link>
            </div>
        </div>
    </div>

</template>

<script>

import Layout from "../../../Shared/Layout";

export default {

    layout:Layout,

    metaInfo() {
        return {
            title: this.lang('categories.overview.meta.title'),
            meta: [
                {vmid:'keywords',name:'keywords',content:this.lang('categories.overview.meta.keywords')},
                {vmid:'description',name:'description',content:this.lang('categories.overview.meta.description')},
            ],
        }
    },

    name:'OpenCategoriesIndex',

    props: {
        categories: {
            required:true,
        },
    },

}

</script>

<style lang="scss">

.categoriesrow > div > a {
    display:block;
    border:1px solid #ccc;
    border-radius:5px;
    padding:10px;
    margin-bottom:20px;
    position:relative;

    > i {
        position:absolute;
        right:10px;
    }
}

</style>
